module.exports = __webpack_public_path__ + "static/img/第十八届.68f0aae.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十八届.png
// module id = 5p05
// module chunks = 1